import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Auth/AuthProvider';

interface AuthorizedRouteProps {
  children: ReactNode;
  redirectTo: string;
}

const AuthorizedRoute: React.FC<AuthorizedRouteProps> = ({ children, redirectTo }) => {
  const { isAuthenticated, isAuthInitialized } = useAuth();
  const location = useLocation();

  if (!isAuthInitialized) {
    return null;
  }

  return isAuthenticated ? (
    <>{children}</>
  ) : (
    <Navigate to={redirectTo} replace state={{ from: location.pathname }} />
  );
};

export default AuthorizedRoute;
